import { render, staticRenderFns } from "./Convites.vue?vue&type=template&id=8851b03e&scoped=true"
import script from "./Convites.vue?vue&type=script&lang=js"
export * from "./Convites.vue?vue&type=script&lang=js"
import style0 from "./Convites.vue?vue&type=style&index=0&id=8851b03e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8851b03e",
  null
  
)

export default component.exports